import { AntDesign } from "@expo/vector-icons";
import { BlurView } from "expo-blur";
import { DocumentPickerAsset } from "expo-document-picker";
import React from "react";
import { useTranslation } from "react-i18next";
import { View, Modal, Pressable, Image, Text } from "react-native";

import Title from "@/components/Title";
import ButtonUploadDoc from "@/components/button/ButtonUploadDoc";

interface UploadModalProps {
  visible: boolean;
  documentType: string;
  onUpload: (
    file: DocumentPickerAsset,
    item?: string,
    individualId?: string
  ) => void;
  onClose: () => void;
  item?: string;
  individualId?: string;
  onlyImage?: boolean;
}

export default function UploadModal(props: UploadModalProps) {
  const { t } = useTranslation();

  return (
    <Modal visible={props.visible} transparent animationType="fade">
      <BlurView intensity={20} className="flex-1 justify-center items-center">
        <View className="p-6 bg-white1 border border-gray rounded-lg w-full h-full items-center relative shadow lg:w-104 lg:h-168">
          <Pressable
            className="absolute right-3 top-3"
            onPress={() => props.onClose()}
          >
            <AntDesign name="close" size={24} color="black" />
          </Pressable>
          <Title text={t("common:modal.upload.title")} />
          <View className="flex-grow w-full items-start justify-center">
            <View className="w-full items-center">
              {props.documentType === "PASSPORT" && (
                <Image
                  source={require("@/assets/passportopened.jpeg")}
                  style={{ height: 180, width: 120, borderRadius: 10 }}
                  resizeMode="contain"
                />
              )}
              {props.documentType === "IDENTITY_CARD_FRONT" && (
                <Image
                  source={require("@/assets/idfront.jpeg")}
                  style={{ height: 100, width: 180, borderRadius: 10 }}
                  resizeMode="contain"
                />
              )}
              {props.documentType === "IDENTITY_CARD_BACK" && (
                <Image
                  source={require("@/assets/idback.jpeg")}
                  style={{ height: 100, width: 180, borderRadius: 10 }}
                  resizeMode="contain"
                />
              )}
              {props.documentType === "DRIVERS_LICENCE_FRONT" && (
                <Image
                  source={require("@/assets/driverslicenseopened.jpeg")}
                  style={{ height: 80, width: 160, borderRadius: 10 }}
                  resizeMode="contain"
                />
              )}
              {props.documentType === "DRIVERS_LICENCE_BACK" && (
                <Image
                  source={require("@/assets/idback.jpeg")}
                  style={{ height: 160, width: 100, borderRadius: 10 }}
                  resizeMode="contain"
                />
              )}
              {props.documentType === "SELFIE" && (
                <Image
                  source={require("@/assets/selfieinstructions.png")}
                  style={{ height: 140, width: 200, borderRadius: 10 }}
                  resizeMode="contain"
                />
              )}
              <Text className="text-sm text-midgray text-center">
                {t("common:modal.upload.subtitle")}
              </Text>
            </View>
            {props.documentType === "SELFIE" && (
              <Text className="mt-1 text-lg">
                • {t("common:modal.upload.topic.sameid")}
              </Text>
            )}
            {props.documentType === "SELFIE" && (
              <Text className="mt-1 text-lg">
                • {t("common:modal.upload.topic.readable")}
              </Text>
            )}
            {props.documentType === "PASSPORT" ? (
              <Text className="mt-4 text-lg">
                • {t("common:modal.upload.topic.passport")}
              </Text>
            ) : (
              <Text className="mt-4 text-lg">
                • {t("common:modal.upload.topic.checkexample")}
              </Text>
            )}
            <Text className="mt-1 text-lg">
              • {t("common:modal.upload.topic.livephoto")}
            </Text>
          </View>
          <ButtonUploadDoc
            label={t("common:button.upload")}
            onClick={(file, item, individualId) => {
              props.onUpload(file, item, individualId);
              props.onClose();
            }}
            item={props.item}
            individualId={props.individualId ? props.individualId : null}
            onlyImage={props.onlyImage}
          />
        </View>
      </BlurView>
    </Modal>
  );
}
